export default __webpack_public_path__ + "static/media/ttaWelcomeImage.b13e10e9.jpeg";